const Logo: React.FC = () => (
  <div className="lg-mt-5 w-full lg:mb-10">
    <img
      className="mx-auto max-w-[90px]"
      alt="Footer logo"
      src="https://cdn.shirtspace.com/assets/shirtspace-badge-8368764dbd3b09e0b5d8d9693166f772739e6f3198392135c162ac7af0082449.svg"
    />
  </div>
);

export default Logo;
